import { appActionTypes } from "../constants/appActionTypes";

export const setTranscriptData = (val) => {
  return { type: appActionTypes.SET_TRANSCRIPT_DATA, payload: val };
};
export const setTranscriptStatus = (val) => {
  return { type: appActionTypes.SET_TRANSCRIPT_STATUS, payload: val };
};
export const integrateCalendarPopup = (val) => {
  return { type: appActionTypes.INTEGRATE_CALENDAR_POPUP, payload: val };
};
export const setAppSettings = (settings) => {
  return { type: appActionTypes.SET_APP_SETTINGS, payload: settings };
};
